var map = {
	"./layout.contribution.darwin": "./src/services/keybinding/keyboardLayouts/layout.contribution.darwin.ts",
	"./layout.contribution.darwin.ts": "./src/services/keybinding/keyboardLayouts/layout.contribution.darwin.ts",
	"./layout.contribution.linux": "./src/services/keybinding/keyboardLayouts/layout.contribution.linux.ts",
	"./layout.contribution.linux.ts": "./src/services/keybinding/keyboardLayouts/layout.contribution.linux.ts",
	"./layout.contribution.win": "./src/services/keybinding/keyboardLayouts/layout.contribution.win.ts",
	"./layout.contribution.win.ts": "./src/services/keybinding/keyboardLayouts/layout.contribution.win.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/services/keybinding/keyboardLayouts sync recursive ^\\.\\/layout\\.contribution\\..*$";